import type { CourseRegistration } from '@kimuno/api-sdk/lib/types/responses/CourseRegistration';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ampliConversionPath, routes } from '../../../constants';
import { getSubscription, selectUser } from '../../../reducers/user.selectors';
import services from '../../../services';
import useRouter from '../../../utils/useRouter';
import { ListItem } from '../ListItem';
import { generateCertificatePDF } from '../utils';

const MyCertificatesPageItem: React.FC<{
	courseRegistration: CourseRegistration;
}> = ({ courseRegistration }) => {
	const { router } = useRouter();
	const { t } = useTranslation();
	const user = useSelector(selectUser);
	const { mindItem, certifiedAt, mindItemId } = courseRegistration;
	const subscription = useSelector(getSubscription);

	const formattedDate = moment(certifiedAt).format('DD.MM.YYYY');

	const onClick = async () => {
		if (!user?.isPremium) {
			services.track.ampliTrackPricingPlansViewedEvent(
				ampliConversionPath.CertificatePage,
				subscription?.status
			);
			return router.push(`/${routes.upgradePackageSelection.root}`);
		}

		const certificateUrl = await generateCertificatePDF(user, mindItemId);
		window.open(certificateUrl, '_blank');
	};

	return (
		<ListItem
			header={mindItem?.course?.type}
			subHeader={`${t('completed on')} ${formattedDate}`}
			title={mindItem?.title}
			buttonText={user && user.isPremium ? t('Download certificate') : t('Upgrade to Download')}
			onButtonClick={onClick}
			testId="certificate-item"
		/>
	);
};

export default MyCertificatesPageItem;
